<template>
  <div class="point">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Point'
}
</script>
